var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_c('label',{staticClass:"vs-input--label",attrs:{"for":""}},[(_vm.selected)?_c('span',[_vm._v("Discount")]):_vm._e()]),_c('v-select',{staticClass:"w-full",attrs:{"options":_vm.discounts,"placeholder":"Discount"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }